export default "__VITE_ASSET__METRD9vo__"